import { apisUrls } from "@/apis";
import { messagesConstants } from "@/constants";
import { globalData } from "@/data";
import { getData } from "@/services";
import { getCookie, removeCookie, setCookie } from "@/utils";

import { hideSendingLoader, openAlert } from "../actions";
import * as types from "../types";

export const getUserInfoHandler = () => async (dispatch) => {
    dispatch({ type: types.AUTH_REQUEST });

    removeCookie(globalData.cookieKeys.user);

    const token = getCookie(globalData.cookieKeys.token);

    const userId = getCookie(globalData.cookieKeys.userId);

    if (token && userId) {
        try {
            const response = await getData(
                apisUrls.admins.getOne,
                userId,
            );

            dispatch({
                payload: {
                    data: {
                        token,
                        user: response.data,
                    },
                },
                type: types.GET_USER_INFO_SUCCESS,
            });
        } catch (err) {
            dispatch({
                payload: { error: messagesConstants.authMsgs.unAuthorized },
                type: types.AUTH_FAIL,
            });

            if (err?.response?.status === 401) {
                removeCookie(globalData.cookieKeys.token);

                removeCookie(globalData.cookieKeys.userId);
            }
        }
    } else {
        dispatch({
            payload: { error: messagesConstants.authMsgs.unAuthorized },
            type: types.AUTH_FAIL,
        });

        removeCookie(globalData.cookieKeys.token);

        removeCookie(globalData.cookieKeys.userId);
    }
};

export const loginHandler = (
    data = {},
    state,
    { request } = {},
) => async (dispatch) => {
    if (state === messagesConstants.success) {
        dispatch({
            payload: { data },
            type: types.USER_LOG_IN_SUCCESS,
        });

        setCookie(
            globalData.cookieKeys.token,
            data.access_token,
        );

        setCookie(
            globalData.cookieKeys.userId,
            data.user.id,
        );

        removeCookie(globalData.cookieKeys.user);

        dispatch(hideSendingLoader());
    } else {
        dispatch({
            payload: { error: request },
            type: types.AUTH_FAIL,
        });

        dispatch(
            openAlert(
                messagesConstants.authMsgs.login.fail,
                messagesConstants.fail,
            ),
        );

        dispatch(hideSendingLoader());
    }
};

export const logoutHandler = () => (dispatch) => {
    dispatch({ type: types.USER_LOG_OUT_SUCCESS });

    removeCookie(globalData.cookieKeys.token);

    removeCookie(globalData.cookieKeys.userId);

    removeCookie(globalData.cookieKeys.user);
};
